import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_application_tab_item_component = _resolveComponent("application-tab-item-component")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_ctx.tabs)
    ? (_openBlock(), _createBlock(_component_el_tabs, {
        key: 0,
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        type: "card",
        class: "main-tab",
        closable: "",
        onTabRemove: _ctx.onCloseTabClick
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.id,
              label: item.name,
              name: item.id,
              onTabClick: _ctx.onCloseTabClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_application_tab_item_component, {
                  view: item.view,
                  params: item.params
                }, null, 8, ["view", "params"])
              ]),
              _: 2
            }, 1032, ["label", "name", "onTabClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onTabRemove"]))
    : _createCommentVNode("", true)
}